/**
 * RetirementSkeleton Component
 * WP-RETIRE-2: Loading skeleton matching card layout
 */

export default function RetirementSkeleton() {
  return (
    <div className="animate-pulse p-4">
      {/* Summary line skeleton */}
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-4" />

      {/* Heatmap skeleton */}
      <div className="space-y-2">
        {/* Header row */}
        <div className="flex gap-2">
          <div className="h-8 bg-gray-200 rounded w-20" />
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-8 bg-gray-200 rounded w-16" />
          ))}
        </div>
        {/* Data rows */}
        {[...Array(3)].map((_, rowIdx) => (
          <div key={rowIdx} className="flex gap-2">
            <div className="h-10 bg-gray-200 rounded w-20" />
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-10 bg-gray-200 rounded w-16" />
            ))}
          </div>
        ))}
      </div>

      {/* Legend skeleton */}
      <div className="flex justify-center gap-4 mt-3">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex items-center gap-1">
            <div className="w-3 h-3 rounded-sm bg-gray-200" />
            <div className="h-3 w-12 bg-gray-200 rounded" />
          </div>
        ))}
      </div>

      {/* Disclaimer skeleton */}
      <div className="h-3 bg-gray-200 rounded w-full mt-4" />
    </div>
  );
}
